import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import _, { capitalize, isEmpty } from 'lodash';
import { DWTCContext } from '../utils/context';
import { Row } from './styles/Row.styled';
import { ColumnMdEight, ColumnThree } from './styles/Column.styled';
import {
  BlockImage,
  CardWrapper,
  FilterCard,
  CardHeader,
  CardBody,
  ButtonCard,
  TwoColumnBlock,
} from './styles/FilterTabBlock.styled';
import { getTranslationByKey } from '../helpers/translation-helper';
// data[0].content
export default function ExperiencesCardFeatured({ data, position, dir, isAllFeatured }) {
  const websiteName = dir === 'rtl' ? 'الموقع الالكتروني' : 'Website';
  const googleMap = dir === 'rtl' ? 'الخريطة' : 'Google maps';
  const { translations } = React.useContext(DWTCContext);
  return (
    <TwoColumnBlock>
      <Row className={`align_center ${position}`}>
        <ColumnMdEight>
          <BlockImage>
            {_.isEmpty(data.image) || (
              <LazyLoadImage
                src={data.image.url}
                alt={data.image.name}
                effect="blur"
                placeholderSrc={data.image ? `${data.image.url}?width=50&quality=50` : null}
              />
            )}
          </BlockImage>
        </ColumnMdEight>
        <ColumnThree>
          <CardWrapper>
            <FilterCard>
              <CardHeader dir={dir}>
                <span dir={dir}>
                  {isAllFeatured
                    ? `${capitalize(data.type)} ${capitalize(data.category)}`
                    : getTranslationByKey(translations, data.subCategory)}
                </span>
                <h3 dir={dir}>{data.title}</h3>
              </CardHeader>
              <CardBody dir={dir}>
                <h4 dir={dir}>{data.subtitle}</h4>
                <p dir={dir}>{data.description}</p>
                <ButtonCard dir={dir}>
                  {isEmpty(data.experienceWebsite) || (
                    <a href={data.experienceWebsite} target="_blank" rel="noreferrer" dir={dir}>
                      {websiteName}
                    </a>
                  )}
                  {isEmpty(data.googleMaps) || (
                    <a href={data.googleMaps} target="_blank" rel="noreferrer" dir={dir}>
                      {googleMap}
                    </a>
                  )}
                </ButtonCard>
              </CardBody>
            </FilterCard>
          </CardWrapper>
        </ColumnThree>
      </Row>
    </TwoColumnBlock>
  );
}
